<template>
    <div>
		<template v-if="leave_report === true">
			<div class="page-top mb-1 mb-3 clearfix">
				<h1 class="mt-0"> Leave Report </h1>
			</div>
            <div class="peopple-managment-main">
                <div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
					<div class="row">
						<div class="col-md-5">
                            <div class="form-group">
                                <label class="label block-label"> Users </label>
                                <select v-model="selected_users" name="selected_users[]" data-live-search="true" class="form-control selectpicker custom-select2" multiple>
                                    <option v-for="(user,index) in users" :value="user.id">{{user.name}}</option>
                                </select>
                            </div>
                        </div>
						<div class="col-md-2">
							<div class="form-group">
                                <br>
								<button @click="exportReport" class="btn btn-primary">Submit</button>
							</div>
						</div>
					</div>
				</div>
			</div>
            <div class="tab-content" id="myTabContent">
                <div v-show="hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                    <div class="empty-main">
                        <div class="empty-inner">
                            <img src="/images/new_empty_payments.png" alt="" />
                            <h2> Hi, {{user}}! </h2>
                            <p> Select your requirements and export your desired report </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="leave_report === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="leave_report === false">
            <notAllowed></notAllowed>
        </template>

    </div>
</template>

<script>
	var dtTable = null;
    export default {
        data() {
            return {
				hasPer : true,
				user : '',
				leave_report: null,
				selected_users:[],
                users: [],
            };
        },
        mounted() {
            this.$Progress.start();
			this.can('leave_report').then(result => {
                this.leave_report = result.leave_report;
                this.user = result.user_name;
            	this.$Progress.finish();
			}).then(result => {
				this.getUsers();
			});
        },
        methods: {
			getUsers(){
				this.$Progress.start();
                axios.get('/api/getUsers')
                .then(res => {
                    if(res.status == 200){
						this.users = res.data.users;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Some error in your form data');
                });
			},

			exportReport: function(){
				this.$Progress.start();
				var formData = {
					'selected_users':this.selected_users,
                }
                axios.post('/api/employee_leave_report', formData,{
					responseType: 'blob'
				})
				.then(res => {
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'employeeLeaveReport.xlsx')
					document.body.appendChild(link)
					link.click();
					this.showToastBox('success','Leave report successfully downloaded');
					this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load form data');
					}
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load form data');
				});
			}
        },

    }
</script>
